import { render } from "./MemberProfilePage.vue?vue&type=template&id=5662207d"
import script from "./MemberProfilePage.vue?vue&type=script&lang=js"
export * from "./MemberProfilePage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__